module.exports = __webpack_public_path__ + "static/img/son1_active.c6661f6e.png";